<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  customerArchivesEdit,
  customerArchivesDetail,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/blackList/edit',
      formComponents: ['baseForm'],
    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: customerArchivesDetail,
    editApi: customerArchivesEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
